<template lang="pug">
    layout
        // Main title
        title-component(
            type="h2"
            slot="title"
            :title="title"
        )

        //Session form
        session-form(
            :isMindfulMinute="isMindfulMinute"
            :isLiveRecorded="isLiveRecorded"
            :isRecorded="isRecorded"
            :isEditing="isEditing"
            :id="id")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import SessionForm from './SessionForm';
    import Title from '~components/Title';
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';

    export default {
        components: {
            Layout,
            SessionForm,
            TitleComponent: Title
        },
        props: {
            isMindfulMinute: VueTypes.bool.def(false),
            isLiveRecorded: VueTypes.bool.def(false),
            isRecorded: VueTypes.bool.def(false),
            isEditing: VueTypes.bool.def(false),
            title: VueTypes.string.def('')
        },
        data() {
            return {
                id: null
            };
        },
        async created() {
            await this.resetSession();
            this.id = this.$route.params.id;
            if (this.id) this.read({ id: this.id });
        },
        methods: {
            ...mapActions('sessions', ['read', 'resetSession'])
        }
    };
</script>
